"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    Constants = require('./constants'),
    DefaultRoute = ReactRouter.DefaultRoute,
    Route = ReactRouter.Route,
    NotFoundRoute = ReactRouter.NotFoundRoute,
    RouteHandler = ReactRouter.RouteHandler,
    CurrentUser = require('./shared/CurrentUser'),
    URI = require('urijs'),
    Project = require('./models/Project'),
    Developer = require('./models/Developer'),
    CurrentUserViews = require('./views/currentuser'),
    Widget = require('./views/widget'),
    search = URI.parseQuery(window.location.search),
    APICode = search.API,
    builderAPICode = search.bAPI,
    ListingCollection = require('./collections/Projects');

var App = require('./views/toolbox/Application'),
    CurrentUserViews = require('./views/currentuser'),
    Toolbox = require('./views/toolbox'),
    // Dashboard = Toolbox.Dashboard,

    NotFound = require('./views/NotFound'),
    Error404 = require('./views/errors/404'),
    ErrorServiceLevel = require('./views/errors/ServiceLevel'),
    DevelopmentUnavailable = require('./views/toolbox/errors/DevelopmentUnavailable');

var routes = (
    React.createElement(Route, {handler: App, path: Constants.root}, 
        React.createElement(DefaultRoute, {handler: Toolbox.Dashboard, name: "Dashboard"}), 

        React.createElement(Route, {handler: Toolbox.Login, name: "Login", path: "login"}), 
        React.createElement(Route, {handler: Toolbox.ForgotPassword, name: "ForgotPassword", path: "forgotpassword"}), 
        React.createElement(Route, {handler: Toolbox.ResetPassword, name: "ResetPassword", path: "resetpassword/:token"}), 
        /* <Route handler={Toolbox.Signup} name="Signup" path="signup"/> */
        React.createElement(Route, {handler: CurrentUserViews.Signup.Container, name: "Signup", path: "signup"}, 
            React.createElement(DefaultRoute, {handler: CurrentUserViews.Signup.EmailCheck, name: "SignupEmailCheck"}), 
            React.createElement(Route, {handler: CurrentUserViews.Signup.Create, name: "SignupCreate", path: "create/:email"}), 
            React.createElement(Route, {handler: CurrentUserViews.Signup.AgentDefaultWidget, name: "SignupWidget", path: "widgets/:id"}), 
            React.createElement(Route, {handler: Widget.Help, name: "SignupWidgetHelp", path: "widgets/:id/help"}), 
            React.createElement(Route, {handler: CurrentUserViews.Signup.Image, name: "SignupImage", path: "image"}), 
            React.createElement(Route, {handler: CurrentUserViews.Signup.DeveloperFinish, name: "SignupCompany", path: "company"})
        ), 

        React.createElement(Route, {handler: Toolbox.Widgets, name: "Widgets", path: "widgets"}), 
        React.createElement(Route, {handler: Toolbox.Documents, name: "Documents", path: "documents"}), 
        React.createElement(Route, {handler: Toolbox.Images, name: "Images", path: "images"}), 
        React.createElement(Route, {handler: Toolbox.FloorPlans, name: "FloorPlans", path: "floorplans"}), 
        React.createElement(Route, {handler: Toolbox.Promotions, name: "Promotions", path: "promotions"}), 
        React.createElement(Route, {handler: Toolbox.PersonalizedEmail, name: "PersonalizedEmail", path: "personalizedemail"}), 
        React.createElement(Route, {handler: Toolbox.PersonalizedBrochure, name: "PersonalizedBrochure", path: "personalizedbrochure"}), 
        React.createElement(Route, {handler: Toolbox.Contact, name: "Contact", path: "contact"}), 

        React.createElement(Route, {handler: NotFound, name: "Help", path: "help"}), 
        React.createElement(Route, {handler: NotFound, name: "Terms", path: "terms"}), 

        React.createElement(Route, {name: "ErrorServiceLevel", handler: ErrorServiceLevel, path: "error-service-level"}), 
        React.createElement(Route, {name: "Error403", handler: NotFound, path: "error-403"}), 
        React.createElement(Route, {name: "Error404", handler: NotFound, path: "error-404"}), 
        React.createElement(Route, {name: "Error500", handler: NotFound, path: "error-500"}), 
        React.createElement(Route, {name: "DevelopmentUnavailable", handler: DevelopmentUnavailable, path: "development-unavailable"}), 
        React.createElement(NotFoundRoute, {handler: NotFound})
    )
);

var router = ReactRouter.create({
        routes: routes,
        location: ReactRouter.HistoryLocation
    }),
    anonymousRoutes = ['/signup', '/forgotpassword', '/resetpassword', '/login', '/error-403', '/error-404', '/error-500', '/development-unavailable'],
    isLoading = true,
    loggedIn = false;

CurrentUser.once('sync', function() {
    isLoading = false;
    loggedIn = true;
});

function redirectToLogin() {
    var currentRoute = router.getCurrentRoutes().pop();
    isLoading = false;
    CurrentUser.destroyCookie();
    if (router.isRunning && currentRoute.name !== 'ForgotPassword' && currentRoute.name !== 'Signup' && currentRoute.name !== 'ResetPassword') {
        router.transitionTo('Login', {}, {
            API: APICode
        });
    }
}

function isCurrentPathAnonymousOrNotfound() {
    var pathname = window.location.pathname.toLowerCase(),
        matchedRoutes = router.match(router.getLocation().getCurrentPath()),
        anonymousRoute = matchedRoutes.routes.pop().isNotFound || _.find(anonymousRoutes, function(path) {
            var isAnonymous = pathname.indexOf(path) === 0;

            if (path === '/signup') {
                isAnonymous = pathname === '/signup' || pathname.indexOf('/signup/create') === 0;
            }

            return isAnonymous;
        });

    return anonymousRoute;
}

function intercomLogin() {
    CurrentUser.intercomLogin();
}

function start() {
    if(builderAPICode) {
        loadByDeveloper(builderAPICode);
    } else {
        loadByProject(APICode);
    }
}

function loadByProject(apiCode) {
    var ProjectModel = new Project({
        name: ':LISTING:'
    });

    return ProjectModel.fetchByAPICode(apiCode, {
        suppressError: true
    }).then(function() {
        onModelSuccess(ProjectModel, {
            project: ProjectModel
        });
    }).fail(function(){
        loadByDeveloper(apiCode);
    });
}

function loadByDeveloper(apiCode) {
    var DeveloperModel = new Developer({
        name: ':LISTING:'
    });
    return DeveloperModel.fetchByAPICode(apiCode).then(function() {
        DeveloperModel.listingCollection = new ListingCollection();
        DeveloperModel.listingCollection.pageSize = null;
        DeveloperModel.listingCollection.developer = DeveloperModel.id;
        DeveloperModel.listingCollection.fetch();
        onModelSuccess(DeveloperModel, {
            builder: DeveloperModel
        });
    }).fail(function() {
        router.transitionTo('DevelopmentUnavailable', undefined, {
            API: apiCode,
            bAPI: builderAPICode
        });
        router.run(function(Handler, state) {
            React.render(React.createElement(Handler, React.__spread({},  state, {hideHeaderAndFooter: true})), document.getElementById('app'));
        });
    });
}

function onModelSuccess(model, viewProps) {
    var anonymousRoute = isCurrentPathAnonymousOrNotfound();

    if (!model.isActive()) {
        router.transitionTo('ErrorServiceLevel', undefined, {
            API: APICode,
            bAPI: builderAPICode
        });
        router.run(function(Handler, state) {
            React.render(React.createElement(Handler, React.__spread({},  state,  viewProps, {hideHeaderAndFooter: true})), document.getElementById('app'));
        });
    } else if (!!anonymousRoute) {
        if (CurrentUser.isLoggedIn()) {
            CurrentUser.fetch().always(function() {
                router.run(function(Handler, state) {
                    React.render(React.createElement(Handler, React.__spread({},  state,  viewProps, {hideHeaderAndFooter: true})), document.getElementById('app'));
                });
            }).fail(function() {
                CurrentUser.destroyCookie();
            }).then(function() {
                intercomLogin();
            });
        } else {
            router.run(function(Handler, state) {
                React.render(React.createElement(Handler, React.__spread({},  state,  viewProps, {hideHeaderAndFooter: true})), document.getElementById('app'));
            });
        }

    } else {
        if (CurrentUser.isLoggedIn()) {
            CurrentUser.fetch().fail(function() {
                CurrentUser.destroyCookie();
                router.transitionTo('Login', undefined, {
                    redirect: window.location.pathname + window.location.search,
                    API: APICode,
                bAPI: builderAPICode
                });
                router.run(function(Handler, state) {
                    React.render(React.createElement(Handler, React.__spread({},  state,  viewProps, {hideHeaderAndFooter: true})), document.getElementById('app'));
                });
            }).then(function() {
                intercomLogin();
                router.run(function(Handler, state) {
                    React.render(React.createElement(Handler, React.__spread({},  state,  viewProps, {hideHeaderAndFooter: true})), document.getElementById('app'));
                });
            });
        } else {
            CurrentUser.destroyCookie();
            router.transitionTo('Login', undefined, {
                redirect: window.location.pathname + window.location.search,
                API: APICode,
                bAPI: builderAPICode
            });
            router.run(function(Handler, state) {
                React.render(React.createElement(Handler, React.__spread({},  viewProps,  state)), document.getElementById('app'));
            });
        }
    }
}

module.exports = {
    router: router,
    start: start,
    isLoading: function() {
        return isLoading;
    }
};
